export default function initials(val, count = 2) {
	let words = val.split(' ')
	let initials = ''
	for (let i = 0; i < Math.min(words.length, count); i++) {
		initials += words[i].charAt(0)
	}
	return initials
}
